import React, { useState } from "react";
import { api, apiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { ImagePlus, Check } from "lucide-react";
import { toast } from "sonner";

const today = () => new Date().toISOString().slice(0, 10);

export function TrackingDialog({ ship, open, onOpenChange, onSaved }) {
  const t = ship.tracking || {};
  const isOther = t.carrier && t.carrier !== "InPost";
  const [carrier, setCarrier] = useState(isOther ? "Altro" : "InPost");
  const [other, setOther] = useState(isOther ? t.carrier : "");
  const [number, setNumber] = useState(t.number || "");
  const [date, setDate] = useState(t.shipped_on || today());
  const [proof, setProof] = useState(t.proof_path || null);
  const [busy, setBusy] = useState(false);

  const upload = async (file) => {
    const fd = new FormData(); fd.append("file", file);
    try { const { data } = await api.post("/uploads/image", fd, { headers: { "Content-Type": "multipart/form-data" } }); setProof(data.path); toast.success("Prova caricata."); }
    catch (e) { toast.error(apiError(e)); }
  };
  const save = async () => {
    setBusy(true);
    try { await api.put(`/shipping/${ship.id}/tracking`, { carrier, carrier_other: other, tracking_number: number, shipped_on: date, proof_path: proof }); toast.success("Tracking salvato."); onOpenChange(false); onSaved(); }
    catch (e) { toast.error(apiError(e)); } finally { setBusy(false); }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-[#141B2D] border-[#2A3655] text-[#F8FAFC]" data-testid="tracking-dialog">
        <DialogHeader>
          <DialogTitle className="font-display">{ship.tracking ? "Modifica tracking" : "Inserisci tracking"}</DialogTitle>
          <DialogDescription className="text-[#94A3B8]">Inseriscilo solo dopo aver acquistato e consegnato il pacco a InPost.{ship.tracking && " Le modifiche sono registrate e limitate."}</DialogDescription>
        </DialogHeader>
        <div className="grid gap-3 sm:grid-cols-2">
          <div><Label className="text-xs text-[#CBD5E1]">Corriere</Label>
            <Select value={carrier} onValueChange={setCarrier}><SelectTrigger data-testid="tracking-carrier" className="bg-[#0B1020] border-[#2A3655]"><SelectValue /></SelectTrigger>
              <SelectContent className="bg-[#141B2D] border-[#2A3655] text-[#F8FAFC]"><SelectItem value="InPost">InPost</SelectItem><SelectItem value="Altro">Altro corriere</SelectItem></SelectContent></Select>
          </div>
          {carrier === "Altro" && <div><Label className="text-xs text-[#CBD5E1]">Nome corriere</Label><Input value={other} onChange={(e) => setOther(e.target.value)} data-testid="tracking-carrier-other" className="bg-[#0B1020] border-[#2A3655]" /></div>}
          <div className="sm:col-span-2"><Label className="text-xs text-[#CBD5E1]">Numero di tracking</Label><Input value={number} onChange={(e) => setNumber(e.target.value)} data-testid="tracking-number" className="bg-[#0B1020] border-[#2A3655] font-mono uppercase" /></div>
          <div><Label className="text-xs text-[#CBD5E1]">Data di spedizione</Label><Input type="date" max={today()} value={date} onChange={(e) => setDate(e.target.value)} data-testid="tracking-date" className="bg-[#0B1020] border-[#2A3655]" /></div>
          <div><Label className="text-xs text-[#CBD5E1]">Prova di spedizione (facoltativa)</Label>
            <label className="flex h-10 cursor-pointer items-center gap-2 rounded-md border border-dashed border-[#2A3655] px-3 text-sm text-[#CBD5E1] hover:border-[#2DD4BF]" data-testid="tracking-proof-label">
              {proof ? <><Check className="h-4 w-4 text-[#10B981]" />Caricata</> : <><ImagePlus className="h-4 w-4" />Carica foto ricevuta</>}
              <input type="file" accept="image/*" className="hidden" onChange={(e) => e.target.files?.[0] && upload(e.target.files[0])} data-testid="tracking-proof-input" />
            </label>
          </div>
        </div>
        <Button onClick={save} disabled={busy || !number.trim()} data-testid="tracking-save" className="bg-[#7C3AED] hover:bg-[#6D28D9]">Salva tracking</Button>
      </DialogContent>
    </Dialog>
  );
}
